import React, { useState, useContext, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { diamondPolish } from "../../utils/diamondData";
import { PriceContext } from "../../context";

const PolishForm = ({ name }) => {
  const getContext = useContext(PriceContext);
  const { setPricestepData, pricestepData,reportType } = getContext;
  const { polish } = pricestepData || {};
  const [show, setShow] = useState(false);
  const [defaultPolish, setDefaultPolish] = useState(polish ? polish : "Select");
  const handleModal = () => {
    if (reportType === "byGia") {
      return;
    }
    setShow(!show);
  };

  useEffect(() => {
    setDefaultPolish(polish ? diamondPolish?.find((s) => s.code === polish)?.displayName : "Select");
  }, [polish]);
  const handleSelect = (value, name, showName) => {
    setDefaultPolish(showName);
    setPricestepData({ ...pricestepData, [name]: value });
    setShow(false);
  };  
  return (
    <>
      <div className="form-wrapper">
        <div
          className={`${reportType ==="byGia"? "disable_input":""} select-section`}
          onClick={handleModal}
          role="presentation"
          style={{
            opacity: `${pricestepData[name] === "" ? "0.5" : "1"}`,
          }}
        >
          <h6>{defaultPolish}</h6>
        </div>     
      </div>
      <PolishSelector
        show={show}
        handleModal={handleModal}
        handleSelect={handleSelect}
        name={name}
      />    
    </>
  );
};

export default PolishForm;

const PolishSelector = ({ show, handleModal, handleSelect, name }) => {
  return (
    <Modal
      className="pi-input-selector"
      show={show}
      onHide={handleModal}
      backdropClassName="backdrop-input-bg"
      centered
    >
      <Modal.Body>
        <div className="input-option-wrapper">
          {diamondPolish.map((el, i) => (
            <div
              className="pi-option-elem"
              onClick={() => handleSelect(el.code, name, el.displayName)}
              key={i}
            >
              {el.displayName}
            </div>
          ))}
        </div>
      </Modal.Body>
    </Modal>
  );
};
